<aur-mat-table
  [tableData]="tableData"
  [tableConfig]="tableConfig"
  (selectedRowsAction)="onRowSelectedRowAction($event)"
></aur-mat-table>
